import React from 'react';
import Channel from './Channel';

const Channels = () => {
  return (
    <div className="pb-5 bg-lightblue">
      <div className="bg-lightblue py-3 px-5 border ">
        Connect Social Media Accounts
      </div>

      <section className="p-5 h-screen flex flex-col gap-5">
        <Channel />
        <Channel />
        <Channel />
        <Channel />
        <Channel />
        <Channel />
      </section>
    </div>
  );
};

export default Channels;
